"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGetSelectedSenderShop;

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

function useGetSelectedSenderShop(shops) {
  var formData = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('transfer-create'));

  if (formData && 'sender' in formData && formData['sender']) {
    return formData['sender'];
  }

  return shops.length ? shops[0] : null;
}